export default "__VITE_ASSET__nfLW0C62__"